module.exports = __webpack_public_path__ + "img/page_arrow.9483ff96.svg";